import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import DatabaseViewer from './DatabaseViewer';
import DatabaseSummary from './DatabaseSummary';
import DatabaseExplorer from './DatabaseExplorer';
import ParkManager from './ParkManager';
import ParkVerification from './ParkVerification';
import ASKILiveData from './ASKILiveData';
import AskiAnalysis from './AskiAnalysis';
import ASKIMonthlyReport from './ASKIMonthlyReport';
import DataInventoryReport from './DataInventoryReport';
import GISDataAnalysis from './GISDataAnalysis';
import styles from './Dashboard.module.css';

const AnalystDashboard = ({ onNavigateToMap }) => {
  const { user, userRole, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('data');
  const [dataSubTab, setDataSubTab] = useState('viewer');

  const tabs = [
    { id: 'data', label: 'Veriler' },
    { id: 'dbmanage', label: 'DB Yönetim' },
    { id: 'parkmanager', label: 'Park Yönetim' },
    { id: 'park-verify', label: 'Park Doğrulama' },
    { id: 'aski-live', label: 'Canlı Veri (ASKİ)' },
    { id: 'aski-analysis', label: 'Dönem Analizi' },
    { id: 'aski-report', label: 'ASKI Rapor' },
    { id: 'data-inventory', label: 'Veri Envanteri' },
    { id: 'gis-analysis', label: 'GIS Analiz' },
  ];

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardHeader}>
        <div>
          <h1>Analist Paneli</h1>
          <p>{user?.email || user?.username} &middot; <span className={styles.roleBadge}>{userRole}</span></p>
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <button
            onClick={logout}
            className={styles.logoutButton}
          >
            Çıkış Yap
          </button>
        </div>
      </div>

      <div className={styles.dashboardTabs}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.dashboardContent}>

        {activeTab === 'data' && (
          <div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
              <button
                onClick={() => setDataSubTab('summary')}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: dataSubTab === 'summary' ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                  background: dataSubTab === 'summary' ? '#eff6ff' : '#fff',
                  color: dataSubTab === 'summary' ? '#2563eb' : '#64748b',
                  fontWeight: dataSubTab === 'summary' ? '600' : '400',
                  cursor: 'pointer',
                  fontSize: '13px',
                }}
              >
                Özet
              </button>
              <button
                onClick={() => setDataSubTab('viewer')}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: dataSubTab === 'viewer' ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                  background: dataSubTab === 'viewer' ? '#eff6ff' : '#fff',
                  color: dataSubTab === 'viewer' ? '#2563eb' : '#64748b',
                  fontWeight: dataSubTab === 'viewer' ? '600' : '400',
                  cursor: 'pointer',
                  fontSize: '13px',
                }}
              >
                Tablo Görüntüleyici
              </button>
            </div>
            {dataSubTab === 'summary' ? <DatabaseSummary /> : <DatabaseViewer />}
          </div>
        )}

        {activeTab === 'dbmanage' && <DatabaseExplorer />}
        {activeTab === 'parkmanager' && <ParkManager />}
        {activeTab === 'park-verify' && <ParkVerification />}
        {activeTab === 'aski-live' && <ASKILiveData />}
        {activeTab === 'aski-analysis' && <AskiAnalysis />}
        {activeTab === 'aski-report' && <ASKIMonthlyReport />}
        {activeTab === 'data-inventory' && <DataInventoryReport />}
        {activeTab === 'gis-analysis' && <GISDataAnalysis />}
      </div>

      <div className={styles.dashboardFooter}>
        <span>Pronuve Su Yönetimi</span>
        <span className={styles.footerSep}>|</span>
        <span>&copy; 2026 Pronuve Yazılım</span>
      </div>
    </div>
  );
};

export default AnalystDashboard;
